//-- global store: import stores directly to avoid dev server circular dependency issues with HMR
import {
  actions as route$actions,
  hooks as route$hooks,
  triggers as route$triggers,
} from ":setup/qrouter/SHARED/store";
import { actions as toast$actions } from ":src/components/toast/store";
import { actions as confirm_dialog$actions } from ":src/components/popup/confirm-dialog/store";
import { actions as modal$actions } from ":src/components/popup/modal/store";
import { hooks as platform$hooks, actions as platform$actions } from ":src/modules/platform/store";

//
import { createOnBreakpoint } from ":setup/qdom";
import breakpoints from ":setup/breakpoints";
import whitelabel from "./whitelabel";

export default {
  hooks: {
    route: route$hooks,
    dom: {
      ...createOnBreakpoint(breakpoints),
    },
    platform: {
      ...platform$hooks,
    },
  },
  triggers: {
    route: route$triggers,
  },
  actions: {
    toast: {
      ...toast$actions,
    },
    popop: {
      ...confirm_dialog$actions,
      ...modal$actions,
    },
    route: {
      ...route$actions,
    },
    platform: platform$actions,
    whitelabel: whitelabel.actions,
  },
};
